import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconFinance = createIcon({
  displayName: 'IconFinance',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M3 7.44982L12 1.81982L21 7.44982V9.99982H13V7.99982H18.11L12 4.17982L5.89 7.99982H11V9.99982H3V7.44982ZM19 12H17V18H19V12ZM21 22V20H3V22H21ZM11 18V12H13V18H11ZM7 12H5V18H7V12Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
